import { ContainerModule } from '@evertel/di'
import {
    ManageRoomsSearchController,
    RoomsUsersExportController,
    RoomsByUserController
} from './controller'

export const DI_WEB_ROOM_MODULE = new ContainerModule((m) => {
    m.bind(ManageRoomsSearchController).toSelf()
    m.bind(RoomsByUserController).toSelf()
    m.bind(RoomsUsersExportController).toSelf()
})
